angular.module("digitalLeasing.module")
  .component("infoBancaPrestoLeasing", {
    templateUrl: "ng/components/digitalLeasing/bancaPrestoLeasing/infoBanca/infoBancaPrestoLeasing.view.html",
    bindings: {
      model: '=',
      validateComponent: '&',
      alreadyUploaded: "<"
    },
    controller: InfoBancaPrestoLeasing,
    controllerAs: "infobankPreLeasCtrl"
  });

function InfoBancaPrestoLeasing(
  $simulationService,
  SelectedNotaPivaRagSocSedeLegale,
  $scope,
  $timeout,
  $configService,
  FileUploader,
  $rootScope,
  $financialApiService,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.loadingStatus = {
      uploading: false,
    };
    var garanzieSelezionate = Object.keys(self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente)
      .map(function (element) {
        return {
          name: element,
          selected: self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente[element].selected
        }
      })
      .filter(function (filtro) {
        return filtro.name != "nessunaGaranzia"
      })
      .some(function (value) {
        return value.selected == true
      })

    self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.nessunaGaranzia.selected = !garanzieSelezionate;
    self.validate();
    self.documentDate = {
      disabledDays: [0],
      disabledDates: [
        "01-01",
        "06-01",
        "25-04",
        "01-05",
        "02-06",
        "15-08",
        "01-11",
        "08-12",
        "25-12",
        "26-12"
      ]
    }
    self.listOfFilesUpload = [];
    self.listOfFilesError = [];
    self.visualProgBarDoc = false;
  }

  self.$onChanges = function (change) {
    if (change.alreadyUploaded && change.alreadyUploaded.currentValue) {
      self.listOfFilesUpload = change.alreadyUploaded.currentValue;
      self.validate();
    }
  }

  self.check = function (el, tipoGaranzia) {
    el.selected = !el.selected;

    if (tipoGaranzia == 'nessunaGaranzia' && el.selected) {
      self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.impegnoRiacquistoForn = SelectedNotaPivaRagSocSedeLegale.build();
      self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.fidejussioneTerziPG = SelectedNotaPivaRagSocSedeLegale.build();
      self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.fidejussioneTerzePF = SelectedNotaPivaRagSocSedeLegale.build();
      self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.fidejussioneSoci = SelectedNotaPivaRagSocSedeLegale.build();
      self.nessunaGaranzia = true;
    } else {
      if (!el.selected) {
        self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente[tipoGaranzia] = SelectedNotaPivaRagSocSedeLegale.build();
      } else {
        self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente.nessunaGaranzia.selected = false;
      }
      self.nessunaGaranzia = false;
    }
    self.validate();
  }

  self.setData = function (data) {
    self.model.leasingData.preventivo.deliberaBanca.dataDelibera = data;
    self.validate();
  }

  self.handleChange = function (tipo, value) {
    console.log(value);
    self.validate();
  }

  self.validate = function () {
    self.isOneWarrantySelected = false;
    self.isOneWarrantySelected = Object.keys(self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente).some(function (element) {
      return self.model.leasingData.preventivo.deliberaBanca.moduloInfoBanca.garanzieCliente[element].selected == true;
    })
    $timeout(function () {
      var test = $scope.infoBanca && $scope.infoBanca.$valid && (self.nessunaGaranzia || self.isOneWarrantySelected && self.model.responseModuloNplInfo)
      self.validateComponent({
        value: test
      })
    }, 1000)
  }

  self.generateLinkInfo = function () {
    if (self.model && self.model.responseModuloNplInfo && self.model.responseModuloNplInfo.rpDocDownInfo && self.model.responseModuloNplInfo.rpDocDownInfo.linkIc) {
      return $configService.getUrl() +
        "/uni/downloadGenericDigital/service-infos/" +
        self.model.responseModuloNplInfo.rpDocDownInfo.linkIc +
        "/?token=" +
        $configService.getAppConfig().token;
    } else {
      return null;
    }
  }

  self.generateLinkInfo = function (element) {
    var url = "/uni/downloadGenericDigital/service-infos/";
    var input = {
      downloadKey: element == 'bank' ? self.model.responseModuloNplInfo.rpDocDownInfo.linkIb : self.model.responseModuloNplInfo.rpDocDownInfo.linkIc
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })

  }

  self.generateLinkPrivacy = function (value) {
    var url = ""
    if (value == 'ENT') {
      if (self.model && self.model.responseModuloNplInfo && self.model.responseModuloNplInfo.rpDocDownInfo && self.model.responseModuloNplInfo.rpDocDownInfo.relativeUrlPriGarEnt) {
        url =
          "/uni/downloadGenericDigital/service-infos/" +
          self.model.responseModuloNplInfo.rpDocDownInfo.relativeUrlPriGarEnt +
          "/"
      } else {
        return null;
      }

    } else if (value == 'PEF') {
      if (self.model && self.model.responseModuloNplInfo && self.model.responseModuloNplInfo.rpDocDownInfo && self.model.responseModuloNplInfo.rpDocDownInfo.relativeUrlPriGarPef) {
        url =
          "/uni/downloadGenericDigital/service-infos/" +
          self.model.responseModuloNplInfo.rpDocDownInfo.relativeUrlPriGarPef +
          "/"
      } else {
        return null;
      }

    }

    $download.getGenericDownload(url)
      .then(function (response) {
        console.log(response);
      })

  }

  self.checkFile = function (el) {
    el.isSelected = !el.isSelected;
  };

  self.genericTrashCheck = function () {
    return (
      self.listOfFilesUpload &&
      self.listOfFilesUpload.some(function (element) {
        return element.isSelected == true;
      })
    );
  }

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.singleFile = self.listOfFilesUpload[index];
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos/" +
      encodeURIComponent(self.model.leasingData.preventivo.anno) +
      "/" +
      encodeURIComponent(self.model.leasingData.preventivo.numero) +
      "/FINANCIAL-" +
      self.model.responseModuloNplInfo.rpDocDownInfo.cdDocPriGar;

    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var filesUpload = document.querySelector(
      "#uploadInput_document").files;
    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    var formData = new FormData();

    jQuery("#uploadInput_document").val("");

    filesUpload.forEach(function (file) {
      formData = new FormData();
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "ndgCliente", self.model.financialCustomer.metadata.riUserG.ndg);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.model.leasingData.id);
      appendToForm(formData, "numeroAnno", self.model.leasingData.preventivo.anno);
      appendToForm(formData, "numeroContratto", self.model.leasingData.contratto.numero);
      appendToForm(formData, "modulo", self.model.leasingData.contratto.modulo);
      appendToForm(formData, "numeroPreventivo", self.model.leasingData.preventivo.numero);
      appendToForm(formData, "cdDoc", self.model.responseModuloNplInfo.rpDocDownInfo.cdDocPriGar);
      appendToForm(formData, "cfClient", self.model.financialCustomer.metadata.riUserG.cf);

      $financialApiService
        .uploadDocOnDigital(formData)
        .then(function (response) {
          if (response.success) {
            $timeout(function () {
              var tmp = {
                docNameLabel: file.name,
                id: response.id,
                cdDoc: self.model.responseModuloNplInfo.rpDocDownInfo.cdDocPriGar,
                status: "1",
                downloadKey: response.downloadKey
              };

              self.visualProgBarDoc = false;
              self.listOfFilesUpload.push(tmp);
              self.disabledForUploadingInProgress = false;
            }, 1);
          } else {
            self.visualProgBarDoc = false;
            self.disabledForUploadingInProgress = false;
          }
        })
        .catch(function (error) {
          self.disabledForUploadingInProgress = false;
          self.visualProgBarDoc = false;
          console.log(error);
        });
    });
  };

  self.generateDownloadLink = function (file) {

    var url = "/uni/downloadDocDigital/service-infos/"
    var input = {
      downloadKey: file.downloadKey
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })

  };
  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document").val("");
    }
    var fileName = fileItem.file.name;
    //if ( ) {
    self.uploader.queue[0].progress = 100;

    self.visualProgBarDoc = true;

    $timeout(function () {
      self.progresso = 100;
    }, 500);
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
    self.uploadInProgess({
      uploadInProgess: true,
    });
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_document").val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    self.uploadInProgess({
      uploadInProgess: false,
    });
    $timeout(function () {
      self.visualProgBarDoc = false;
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_document").val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc = false;

      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    }, 1);
    jQuery("#uploadInput_document").val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deletePrivacyDocument = function (index) {
    self.progresso = 100;

    self.visualProgBarDoc = true;

    $timeout(function () {
      self.progresso = 0;
    }, 200);

    self.documentsToBeDeleted = self.listOfFilesUpload.filter(function (elem) {
      return elem.isSelected == true;
    });

    self.documentsToBeDeleted.forEach(function (element) {
      $simulationService
        .deleteChecklistFileDigital(element.id)
        .then(function (response) {
          console.log(response);
          if (response.success) {
            $timeout(function () {
              self.visualProgBarDoc = false;
              self.listOfFilesUpload = self.listOfFilesUpload.filter(function (e) {
                return e.isSelected != true;
              });
              self.uploadOk = false;
            }, 1);
          } else {
            $rootScope.$broadcast("addAlert", {
              text: "ERROR_TEC",
            });
            self.visualProgBarDoc = false;
            self.uploadOk = false;
          }
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
        });
    });
  };

}